// extracted by mini-css-extract-plugin
export default {"input":"radio-input_input__-dx5K","label":"radio-input_label__Wtd29"};